import Box from "@material-ui/core/esm/Box";
import React, { useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AddressDialog from 'components/AddressDialog/AddressDialog';
import AddressItem from 'components/AddressItem/AddressItem';
import { AddAddressButton } from 'components/Button';
import Spinner from 'components/Spinner/Spinner';
import { Title, Header } from 'components/Text';
import AddressTypes from 'constants/addressTypes';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import useCustomerAddress from 'hooks/customer/useCustomerAddress';
import useAddressForm from 'utils/form/useAddressForm';
import AddressCheck from './AddressCheck';
export default function Address() {
  const {
    t
  } = useTranslation();
  const {
    customer
  } = useCurrentCustomer();
  const [showNewDeliveryDialog, setShowNewDeliveryDialog] = useState(false);
  const shippingAddress = customer?.shippingAddress;
  const addressForm = useAddressForm(shippingAddress);
  const {
    isLoading,
    changeAddress
  } = useCustomerAddress();
  if (!customer?.customerAddress) {
    return /*#__PURE__*/React.createElement(Title, null, t('profile.no_address'));
  }
  if (customer && isLoading) {
    return /*#__PURE__*/React.createElement(Spinner, null);
  }
  const onSave = (addressType, data) => {
    changeAddress(addressType, data);
  };
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Header, null, t('profile.addresses')), /*#__PURE__*/React.createElement(AddressItem, {
    address: customer.customerAddress,
    title: t('profile.edit_address'),
    addressType: AddressTypes.CUSTOMER,
    onSave: onSave,
    isLoading: isLoading
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AddressCheck, null, t('profile.standard_billing_address')), !shippingAddress && /*#__PURE__*/React.createElement(AddressCheck, null, t('profile.standard_delivery_address')))), shippingAddress && /*#__PURE__*/React.createElement(AddressItem, {
    address: shippingAddress,
    title: t('profile.edit_delivery_address'),
    addressType: AddressTypes.SHIPPING,
    onSave: onSave,
    isLoading: isLoading
  }, /*#__PURE__*/React.createElement(AddressCheck, null, t('profile.standard_delivery_address'))), !shippingAddress && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AddAddressButton, {
    onClick: () => setShowNewDeliveryDialog(true)
  }, t('profile.add_shipping_address')), /*#__PURE__*/React.createElement(FormProvider, addressForm, /*#__PURE__*/React.createElement(AddressDialog, {
    dialogTitle: t('profile.delivery_address'),
    open: showNewDeliveryDialog,
    onClose: () => setShowNewDeliveryDialog(false),
    onPrimaryBtnClick: addressForm.handleSubmit(data => {
      onSave(AddressTypes.SHIPPING, data);
      setShowNewDeliveryDialog(false);
    }),
    isLoading: isLoading,
    primaryBtnClickIsDisabled: isLoading || !addressForm.formState.isValid,
    primaryBtnTitle: t('buttons.save')
  }))));
}